import { Languages } from './languages';
import { Language } from './language';

export class LanguageService {
  static readonly DEFAULT_LANGUAGE: string = 'es';

  static activeLanguages(): Array<Language> {
    return [Languages.getByCode('es'), Languages.getByCode('pt'), Languages.getByCode('en')];
  }
}
